import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { currentBoardIdSelector } from '../../../../../element/board/boardSelector';
import getGridSize from '../../../../../utils/grid/gridSizeSelector';

// Utils
import friendlyDateFormatter from '../../../../../../common/utils/datetime/friendlyDateFormatter';

// Components
import TrashElementWrapper from './TrashElement';

// Constants
import { IN_LIST_MODE } from '../../../../../../common/inList/listTypes';
import { TrashListOrderedContent, TrashElementTypes } from './trashElementTypes';

// Styles
import './TrashElementList.scss';
const mapStateToProps = createStructuredSelector({
    currentBoardId: currentBoardIdSelector,
    gridSize: getGridSize,
});

type TrashElementListProps = {
    childElementIds: string[];
    gridSize: number;
    currentBoardId: string;
    trashListOrderedContent: TrashListOrderedContent;
    initialElementsVisibility: Map<string, boolean>;
    elementPlaceholderMeasurements: Map<string, { width: number; height: number }>;
    allowElementPlaceholder: boolean;
};

const TrashElementList = (props: TrashElementListProps) => {
    const {
        childElementIds,
        gridSize,
        currentBoardId,
        trashListOrderedContent,
        initialElementsVisibility,
        elementPlaceholderMeasurements,
        allowElementPlaceholder,
    } = props;

    return (
        <div className={'TrashElementList'}>
            {childElementIds.map((listElementId: string) => {
                const listElement = trashListOrderedContent.get(listElementId);
                if (!listElement) return null;

                // Date separator
                if (listElement.type === TrashElementTypes.DATE) {
                    const { timestamp } = listElement;
                    if (!timestamp) return null;

                    return (
                        <div key={listElementId} className="date-header">
                            {friendlyDateFormatter({ timestamp })}
                        </div>
                    );
                }

                // Trash element
                return (
                    <TrashElementWrapper
                        key={listElementId}
                        inTrash
                        isPresentational
                        permissions={31}
                        inList={IN_LIST_MODE.IN_LIST_TRASH}
                        elementId={listElement.elementId}
                        currentBoardId={currentBoardId}
                        gridSize={gridSize}
                        allowElementPlaceholder={allowElementPlaceholder}
                        initialElementsVisibility={initialElementsVisibility}
                        elementPlaceholderMeasurements={elementPlaceholderMeasurements}
                    />
                );
            })}
        </div>
    );
};

export default connect(mapStateToProps)(TrashElementList);
